import { DealerData } from "../types";

export const getSelectedDealers = <T>(selection: string[], all_dealers: DealerData[], property: keyof DealerData = "name"): T[] => {
  const dealers: T[] = [];

  all_dealers.forEach(dealer => selection.includes(dealer.static_dealer_id) ? dealers.push(dealer[property] as unknown as T) : null);

  return dealers;
}
